import { LocalDate } from '@js-joda/core';

import { dateFormatter, useTranslate } from '@dreryk/react-common';
import { StyledFlex } from '@dreryk/react-components';

type HistoricalVisitLeaveProps = {
   readonly dateFrom: LocalDate;
   readonly dateTo: LocalDate;
};

const HistoricalVisitLeave = (props: HistoricalVisitLeaveProps): JSX.Element => {
   const translate = useTranslate();
   const dateFrom = dateFormatter(props.dateFrom);
   const dateTo = dateFormatter(props.dateTo);
   return (
      <StyledFlex direction='column'>
         <div>{translate('visit:sidePanel:historicalVisits:historicalVisit:leaveIssuedForDatePeriod')}</div>
         <div>{`${dateFrom}-${dateTo}`}</div>
      </StyledFlex>
   );
};

export { HistoricalVisitLeave };
